// 库存调拨单
export default {
  //查询库存调拨单列表
  GET_LIST_API: '/warehouse/storageAllot/listStorageAllots',
  //保存
  SAVE_API: '/warehouse/storageAllot/addStorageAllot',
  //提交
  SUBMIT_API: '/warehouse/storageAllot/submitToApproval',
  //详情
  DETAIL_API: '/warehouse/storageAllot/queryDetailByAllotNo',
  /**业务入库批次列表 */
  LIST_INBOUND: '/warehouse/storageBatch/listStorageBatchByPublic',
  /** 根据单价和数量计算金额 */
  GET_AMOUNT: '/sales/orderSalesReturn/getReturnMoneyAmount',
  /** 生成物流运输单 */
  SAVE_DELIVERY: '/warehouse/delivery/saveDelivery',
  /** 撤销 */
  REVOKE_API: '/warehouse/storageAllot/revoke',
  /** 冲销 */
  REVERSE_API: '/warehouse/storageAllot/doReverse',
  /** 生效确认 */
  CONFIRM_API: '/warehouse/storageAllot/confirm',
  //调拨单生成运输单查重
  CALC_PICK_DELIVERY: '/warehouse/delivery/listDeliveryBillByOtherNo',
  // 删除 sxp add TAPD-ID1001775 20210318
  DEL_API: '/warehouse/storageAllot/delStorageAllot',
};
